module.exports = __webpack_public_path__ + "files/b8cbab6b733aba7a9709429d0e67fc1c.png";